/**
 * A Malaysian IC, written the way the user wants to read it: twelve digits and
 * nothing else — 861002565414, not 861002-56-5414 and not 861002 56 5414.
 * (user 2026-11-05: "for the ic format without dash please. and stay malaysia format")
 *
 * ICs reached us in every shape a person can type one. Of the 500 customers who
 * have one, 163 were already clean, 129 carried dashes and 204 carried spaces —
 * 496 of the 500 are a perfectly good IC wearing punctuation.
 *
 * So the rule is: strip everything that is not a digit, and if exactly twelve
 * digits remain, that is the IC. Anything else is handed back UNCHANGED rather
 * than reformatted — the remaining 4 rows hold things like 2313213231 and
 * 9333333333-33303, and a half-cleaned version of a wrong number is harder to
 * recognise as wrong than the original. Showing it as typed is honest.
 *
 * This is display and entry only. It never rewrites what is stored, and the
 * birthday helper reads digits anyway, so nothing downstream shifts.
 */

/** The 12-digit IC for display, or the original text when it is not one. */
export function formatIc(ic) {
    const raw = String(ic ?? '').trim();
    if (!raw) return '';
    const digits = raw.replace(/\D/g, '');
    return digits.length === 12 ? digits : raw;
}

/**
 * What an IC field should hold as it is being typed: digits only, capped at 12.
 *
 * Capping matters more than it looks. Without it a stray keypress makes a
 * 13-digit value that `formatIc` then refuses to recognise, and the field
 * silently stops being an IC.
 */
export function icInput(raw) {
    return String(raw ?? '').replace(/\D/g, '').slice(0, 12);
}

/** True when this is a usable 12-digit Malaysian IC. */
export function isIc(ic) {
    return String(ic ?? '').replace(/\D/g, '').length === 12;
}
